export const editProfileIdMap = {
    toAvatarId: (avatarId)=>avatarId,
    toColorId: (colorId)=>colorId,
    fromAvatarId: (avatarId)=>avatarId,
    fromColorId: (colorId)=>colorId
};
